export const OKTA_INTERNAL_CONFIG = {
  issuer: `${process.env.REACT_APP_INTERNAL_ISSUER}`,
  clientId: `${process.env.REACT_APP_GSPT_CLIENT_ID}`,
  redirectUri: `${process.env.REACT_APP_OKTA_REDIRECT_URL}`,
  scopes: ['openid', 'profile', 'email', 'offline_access'],
  pkce: true,
}

// ENABLE THIS FOR LOCAL TESTING
// export const OKTA_INTERNAL_CONFIG = {
//   issuer: `https://secure.ite.pepsico.com/oauth2/default`,
//   clientId: `0oa2dyd0xf6cBA5Rj0h8`,
//   redirectUri: `http://localhost:3000/login/callback`,
//   scopes: ['openid', 'profile', 'email', 'offline_access'],
//   pkce: true,
// }